import { render, staticRenderFns } from "./SelectedContact.vue?vue&type=template&id=290b2e2a"
import script from "./SelectedContact.vue?vue&type=script&lang=js"
export * from "./SelectedContact.vue?vue&type=script&lang=js"
import style0 from "./SelectedContact.vue?vue&type=style&index=0&id=290b2e2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports